import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { store } from './store/store';
import { routes } from './routes';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import Vuelidate from "vuelidate";
import LoadScript from 'vue-plugin-load-script';
import Toast from "vue-toastification";
import VueGtag from "vue-gtag";
import "vue-toastification/dist/index.css";

Vue.use(LoadScript);
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueNumberInput);
Vue.use(Vuelidate);
Vue.use(Toast, {
  maxToasts: 100,
  transition: 'Vue-Toastification__bounce',
  transitionDuration: 750,
  draggable: true,
  draggablePercent: 0.6,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  closeOnClick: true,
  timeout: 1000,
  container: document.body,
  toastClassName: [],
  bodyClassName: [],
  hideProgressBar: false,
  hideCloseButton: false,
  icon: true
});
//Vue gtag is to add google analytics script.
Vue.use(VueGtag, {
  config: { id: "UA-64586946-15" }
});


//Change Country code for northerncontainersales.com to CA. 
const servername = window.location.hostname;
var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/png';
link.rel = 'icon';
//Change favicon based on country code.
if (servername.includes('northerncontainersales')) {
  link.href = 'https://images-ncs.s3-us-west-2.amazonaws.com/favicon.ico';
  store.state.country_code = 'CA'
}
else {
  link.href = 'https://images-wcs.s3-us-west-2.amazonaws.com/New-Western-Container-Sales-Favicon-Logo-Shipping-Containers-For-Sale-Conex-Box-Rent-Storage-Container-514px-square.png';
  store.state.country_code = 'US'
}
document.getElementsByTagName('head')[0].appendChild(link);


//Initialize zipcode.
store.state.VuexZipcode = localStorage.zipcode || "";
//get cart line item from local storage
store.state.VuexCartItem = JSON.parse(localStorage.getItem("cartItem")) || new Array(0);
//Get containers list from local storage
store.state.VuexRentalContainersList = JSON.parse(localStorage.getItem("containersList")) || null;
//Get predelivery data from session storage.
store.state.VuexPredelivery =
  JSON.parse(sessionStorage.getItem("PreDeliveryAnswers")) || store.state.VuexPredelivery;
//Initialize terms and conditions checkbox using local storage
store.state.terms_conditions = JSON.parse(sessionStorage.getItem("Terms_Conditions")) || false ;


const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  store,
  router,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')



